import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, IconButton, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { unit } from '@hcr/ui'

import { COLORS, ICONS } from '../../../../../../libs/ui/src/lib/constants'

import { OwnerBuyAccommodationDrawerMode } from './OwnerBuyAccomodationDrawerMode'

interface OwnerBuyInternationalDestinationProps {
  onClose: () => void
  setMode: (
    value:
      | ((prevState: OwnerBuyAccommodationDrawerMode) => OwnerBuyAccommodationDrawerMode)
      | OwnerBuyAccommodationDrawerMode
  ) => void
}

const RCI_CARD_NUMBER = '24681012'

export const OwnerBuyInternationalDestination: FC<OwnerBuyInternationalDestinationProps> = ({ onClose, setMode }) => {
  const { t } = useTranslation()

  const handleCopy: () => Promise<void> = async () => {
    try {
      await navigator.clipboard.writeText(RCI_CARD_NUMBER)
    } catch {
      /* clipboard API not available */
    }
  }

  return (
    <Stack>
      <Stack justifyContent='right' flexDirection='row'>
        <IconButton onClick={() => setMode(OwnerBuyAccommodationDrawerMode.ACCOMMODATION)} aria-label={t('home.close')}>
          <FontAwesomeIcon size={'sm'} icon={ICONS.farXmark} />
        </IconButton>
      </Stack>
      <Stack direction='column' gap={unit(6)}>
        <Stack direction='column' gap={unit(1)}>
          <Typography variant='titleM'>
            {t('home.owner-buy-international-destination.international-destinations')}
          </Typography>
          <Typography variant='headlineL' color={COLORS.burgundi[500]}>
            {t('home.owner-buy-international-destination.booking-via-rci')}
          </Typography>
        </Stack>
        <Typography variant='bodyM'>{t('home.owner-buy-international-destination.description1')}</Typography>
        <Typography variant='bodyM'>{t('home.owner-buy-international-destination.description2')}</Typography>
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <Stack direction='column'>
            <Typography variant='labelM'>{t('home.owner-buy-international-destination.membership-number')}</Typography>
            <Typography variant='bodyM'>{RCI_CARD_NUMBER}</Typography>
          </Stack>
          <IconButton
            onClick={handleCopy}
            aria-label={t('home.owner-buy-international-destination.copy-membership-number')}
            size='small'
          >
            <FontAwesomeIcon icon={ICONS.falCopy} fontSize={unit(6)} />
          </IconButton>
        </Stack>

        <Typography variant='bodyM'>{t('home.owner-buy-international-destination.description3')}</Typography>
        <Typography
          component='a'
          target={'_blank'}
          rel={'noopener noreferrer'}
          href={''}
          variant='textLinkM'
          color={COLORS.burgundi[500]}
        >
          {t('home.owner-buy-international-destination.read-more-about-rci')}
        </Typography>
      </Stack>
      <Stack direction='column' gap={unit(3)} marginTop={unit(10.5)}>
        <Button variant='contained'>{t('home.owner-buy-international-destination.go-to-rci-service')}</Button>
        <Button
          variant='outlined'
          color='inherit'
          onClick={() => setMode(OwnerBuyAccommodationDrawerMode.ACCOMMODATION)}
        >
          {t('home.owner-buy-international-destination.close')}
        </Button>
      </Stack>
    </Stack>
  )
}
